import { render, staticRenderFns } from "./DialogRight.vue?vue&type=template&id=f1a70d6e&"
import script from "./DialogRight.vue?vue&type=script&lang=js&"
export * from "./DialogRight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports